import { FONT_FAMILY_KEY } from '../constants/localStorage';
import { DEFAULT_FONT_FAMILY, INHERIT_FONT_FAMILY } from '../constants/lw';

import { getStorage, setStoreParam } from './localStorage';

/**
 * Loads a font from Google Fonts if it is cached in storage and not a default or inherited font.
 */
export const fetchFont = (): void => {
  const cachedFontFamily = getStorage()[FONT_FAMILY_KEY] as string | undefined;

  if (cachedFontFamily && ![INHERIT_FONT_FAMILY, DEFAULT_FONT_FAMILY].includes(cachedFontFamily)) {
    [cachedFontFamily].forEach((font) => {
      const encodedFont = encodeURIComponent(font);
      const alreadyLoaded = document.querySelector(
        `link[rel="preload"][href*="${encodedFont}"], link[rel="stylesheet"][href*="${encodedFont}"]`,
      );

      if (!alreadyLoaded) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(font)}&display=swap`;
        document.head.appendChild(link);
      }
    });
  }
};

if (typeof getStorage()[FONT_FAMILY_KEY] !== 'string') {
  setStoreParam(FONT_FAMILY_KEY, 'Roboto');
}

fetchFont();
